import { render, staticRenderFns } from "./ScormViewer.vue?vue&type=template&id=f1aab1d2&scoped=true"
import script from "./ScormViewer.vue?vue&type=script&lang=js"
export * from "./ScormViewer.vue?vue&type=script&lang=js"
import style0 from "./ScormViewer.vue?vue&type=style&index=0&id=f1aab1d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1aab1d2",
  null
  
)

export default component.exports